import React from 'react';

/* USE w for horizontal length, for vertical length it will take the whole height if nothing is specified */
function Separator({
	className = 'w-10/12 border-t-2',
	style = {}
}) {
	return <div
		id='Separator'
		className={className}
		style={style}
	/>;
}

export default Separator;
